import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function AuthSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      // Decode the JWT to get user info
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const user = {
          id: payload.userId,
          email: payload.email,
          role: payload.role,
          token: token
        };
        
        // Store in localStorage
        localStorage.setItem('user', JSON.stringify(user));
        
        // Redirect based on role
        if (user.role === 'student') {
          navigate('/student-dashboard');
        } else {
          navigate('/professor-dashboard');
        }
      } catch (error) {
        console.error('Token parsing error:', error);
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [navigate, searchParams]);

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h2>Completing login...</h2>
    </div>
  );
}